import React, { Fragment } from "react";
import LockOpenTwoToneIcon from '@material-ui/icons/LockOpenTwoTone';
import { useDispatch } from "react-redux";
import CustomizedDialogs from "../../atoms/dialog";
import { useSelector } from 'react-redux'
import Auth from "../../../store/auth/actions";
import Divider from '@material-ui/core/Divider';
import Popover from '@material-ui/core/Popover';
import { handleSnackBar, setIsDocumentClicked } from "../../../store/global/actions";
import { getCodeEditStatus } from "../../../store/global/selectors";
import { MenuItem } from "@material-ui/core";
import { getLoggedUsername } from "../../../store/auth/selectors"
import { ChangePasswordForm } from '../user/ChangePassword'
import PowerSettingsNewRoundedIcon from '@material-ui/icons/PowerSettingsNewRounded';
import { useHistory } from "react-router-dom";
import Typography from '@material-ui/core/Typography';

export const UserDetailsDropDown = (props) => {

    const { anchorEl, handleClose } = props;
    const [openChangePassword, setOpenChangePassword] = React.useState(false);
    const open = Boolean(anchorEl);
    //const toggleOpen = () => setOpenChangePassword((prev) => !prev);
    const dispatch = useDispatch();
    const history = useHistory();
    const loggedInUsername = useSelector(getLoggedUsername)
    const codeEditStatus = useSelector(getCodeEditStatus);

    const style = {
        backgroundColor: '#4d6073',
        'text-align': 'center',
        padding: '0.4rem',
        color: 'white',
    };

    const logout = () => {
        if (codeEditStatus) {
            dispatch(setIsDocumentClicked());
            return;
        }
        dispatch(Auth.logout());
        history.push(`/`);
    }

    const toggleOpen = () => setOpenChangePassword((prev) => !prev);

    const openChangePasswordDialog = () => {
        setOpenChangePassword(true);
    }

    const onCompletionChangePassword = () => {
        dispatch(handleSnackBar({ open: true, message: 'Password Updated Successfully', severity: "success", autoHideDuration: 2000 }));
    }

    return (
        <Fragment>
            <Popover
                id='simple-popover'
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                PaperProps={{id: 'user-popover'}}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <Typography variant="body1" style={style}>&nbsp;{loggedInUsername}</Typography>

                <MenuItem onClick={openChangePasswordDialog}><LockOpenTwoToneIcon />&nbsp;Change Password</MenuItem>
                <Divider variant="middle" />
                <MenuItem onClick={logout}><PowerSettingsNewRoundedIcon />&nbsp;Log Out</MenuItem>
            </Popover>
            <Fragment>
                <CustomizedDialogs
                    open={openChangePassword}
                    container_id="change-password"
                    title="Change Password"
                    handleClose={toggleOpen}
                >
                    <ChangePasswordForm onClose={toggleOpen} onCompletion={onCompletionChangePassword} />
                </CustomizedDialogs>
            </Fragment>
        </Fragment >
    );
}